import { SubscriptionPeriod } from "../../../types";
import { OneMonthInMs, OneYearInMs } from "../../../utils/convertUtils";

export const EstimateSummaryPeriod: React.FC<{
  partialDurationMs?: number;
  subscriptionPeriod: SubscriptionPeriod;
}> = ({ partialDurationMs, subscriptionPeriod }) => {
  const period = subscriptionPeriod === SubscriptionPeriod.Yearly ? "year" : "month";

  const partialDuration = partialDurationMs
    ? subscriptionPeriod === SubscriptionPeriod.Yearly
      ? partialDurationMs / OneYearInMs
      : partialDurationMs / OneMonthInMs
    : undefined;

  if (partialDuration && partialDuration.toPrecision(1) !== "1") {
    return (
      <>
        <s>{`1 ${period}`}</s>
        <span>{` ${partialDuration.toPrecision(1)} ${period}`}</span>
      </>
    );
  }

  return <span>{`1 ${period}`}</span>;
};
